var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.076 12.913v1.444H19l-.31 2.402h-1.614v5.672a7.093 7.093 0 01-2.234-.04v-5.632H13l.037-2.402h1.805v-2.078c0-1.54 1.216-3.358 4.158-2.602v2.017l-.893.019c-.616.013-1.03.495-1.03 1.2h-.001z",
    fill: "#0E0E0E"
  })));
}

export default SvgFacebookinline;